<template>
    <div>
        <div style="height:0.5rem">
            <div>
              <img class="public-img" src="../../assets/image/Profile/profile-icon.png">
              <label class="profile-name">alfred24 point</label>
            </div>
            <label style="color: transparent;">alfred24 point</label>
            <div class="open-width">
                <button class="public-head-language" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"
                  style="
                    display: flex;
                    min-width: 100px;
                    align-items: center;
                    justify-content: space-between;
                    padding-left: 15px;
                    padding-right: 15px;
                    text-wrap: nowrap;
                  "
                >
                    <p>{{languageName}}</p>
                    <span class="caret open-width-caret"></span>
                </button>
                <ul class="dropdown-menu public-head-language-menu" aria-labelledby="dropdownMenu1">
                  <li v-for="list in languages" @click="choiceLanguage($event)" v-bind:data-langcode="list.langcode" v-bind:key="list.langcode">
                    <a href="javascript:void(0);">{{list.name}}</a>
                  </li>
                </ul>
            </div>
        </div>
        <div>
            <span class="iconfont icon-home3 " @click="goHome"></span>
            <p class="Profile-p">
                {{language === '繁體中文' ? locationName : locationNameEn}}
            </p>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Head',
  data () {
    return {
      language: 'en',
      languageName: 'English',
      // languages: [
      //   {name: 'English'},
      //   {name: '繁體中文'}
      // ],
      languages: window.config.VUE_APP_LANG_LIST.split(';').map(x => {
        return {
          name: x.split(':')[0],
          langcode: x.split(':')[1]
        }
      }),
      locationName: localStorage.getItem('locationName'),
      locationNameEn: localStorage.getItem('locationNameEn')
    }
  },
  created () {
    let lang = localStorage.getItem('lang')
    // if (lang === 'zh_HK') {
    //   this.language = '繁體中文'
    // } else if (lang) {
    //   this.language = lang
    // }
    let _lang = window.config.VUE_APP_LANG_LIST.split(';').map(x => {
      return {
        name: x.split(':')[0],
        langcode: x.split(':')[1]
      }
    }).find(x => x.langcode === lang)
    this.language = _lang.langcode
    this.languageName = _lang.name
  },
  methods: {
    choiceLanguage (e) {
      this.languageName = e.currentTarget.firstElementChild.innerText
      this.language = e.currentTarget.getAttribute('data-langcode')
      let lang = this.language
      this.$i18n.locale = lang
      // if (lang === '繁體中文') {
      //   lang = 'zh_HK'
      //   this.$i18n.locale = 'zh'
      // } else if (lang === 'English') {
      //   this.$i18n.locale = 'en'
      // } else {
      //   this.$i18n.locale = 'en'
      // }
      localStorage.setItem('lang', lang)
    },
    goHome () {
      this.$router.push('/')
    }
  }
}
</script>
<style src="../../assets/css/bootstrap.css" scoped>
</style>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Acount/Head.vue